import React from 'react';
import PropTypes from 'prop-types';
import './FloatingSelect.scss';

function FloatingSelect({
  name,
  value,
  label,
  placeholder,
  onChange,
  options,
  required,
  disabled,
  optionObjectKeyName,
  optionObjectValueName,
}) {
  return (
    <div className="form-group">
      <label htmlFor={name} className="floating-select-label">
        <div>{value || placeholder ? label : ''}</div>
        <select
          data-testid={`select-${name}`}
          name={name}
          value={value || ''}
          onChange={e => {
            onChange(e);
          }}
          className="form-control floating-select"
          required={required}
          disabled={disabled}
        >
          <option value="" disabled>
            {placeholder || label}
          </option>
          {/* We can send options prop as array of strings or array of objects
          if we want to use options prop as array of objects then we should also
          send optionObjectKeyName as well to display the text for the option and we
          should use index as the value of the option. */}
          {options.map((option, index) =>
            optionObjectKeyName ? (
              <option
                key={option[optionObjectKeyName]}
                value={
                  optionObjectValueName ? option[optionObjectValueName] : index
                }
              >
                {option[optionObjectKeyName]}
              </option>
            ) : (
              <option key={option} value={option}>
                {option}
              </option>
            ),
          )}
        </select>
      </label>
    </div>
  );
}

FloatingSelect.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  optionObjectKeyName: PropTypes.string,
  optionObjectValueName: PropTypes.string,
};

export default FloatingSelect;
